(function ($) {
    $(document).ready(function () {
        $(".faq-trigger").on("click", function () {
            let $this = $(this);
            let $item = $this.closest(".faq-item");

            if ($item.hasClass("active")) {
                $item.removeClass("active"); // Закриваємо активну панель
            } else {
                $(".faq-item").removeClass("active"); // Закриваємо всі інші панелі
                $item.addClass("active"); // Відкриваємо вибрану панель
            }
        });
    });
})(jQuery); 
